export default __webpack_public_path__ + "1e85ceeaad373f06ebecc7e744740f1c.png";